import {
    useLayoutEffect,
    useRef
} from "react";
import type {
    View
} from "react-native";
import type {
    CalendarCellHandlersConstantType,
    CalendarCellKeyboardEventType,
    CalendarCellHandlers
} from "./type";

const useCalendarCellHandlers = ({
    onKeyDown,
    cellRefs,
    onFocus,
    onPress
}: CalendarCellHandlersConstantType): (index: number) => CalendarCellHandlers => {
    const latestRef = useRef({
        onKeyDown,
        onFocus,
        onPress
    });

    const cacheRef = useRef(new Map<number, CalendarCellHandlers>());

    useLayoutEffect(() => {
        latestRef.current = {
            onKeyDown,
            onFocus,
            onPress
        };
    });

    return (index: number) => {
        const cachedHandlers = cacheRef.current.get(index);

        if(cachedHandlers) {
            return cachedHandlers;
        }

        const handlers: CalendarCellHandlers = {
            onKeyDown: (event: CalendarCellKeyboardEventType) => {
                latestRef.current.onKeyDown(event, index);
            },
            onFocus: () => {
                latestRef.current.onFocus(index);
            },
            onPress: () => {
                latestRef.current.onPress(index);
            },
            ref: (node: View | null) => {
                cellRefs.current[index] = node;
            }
        };

        cacheRef.current.set(index, handlers);

        return handlers;
    };
};
export default useCalendarCellHandlers;
